export default Object.freeze({
  PROVEEDOR: 3,
  MIPE: 1,
  QUERELLA: 2,
  REMEDIOPROVISIONAL: 4,
  PADRES: 5,
});
